import DashboardRouter from '@/dashboard/DashboardRouter';

const Dashboard = () => {
  return <DashboardRouter />;
};

export default Dashboard;
